import { fetchChatUsers } from '@app/api'
import { SpamChecksResponse } from '@app/models/SpamCheckEvent'
import { SpamListEntriesResponse } from '@app/models/SpamListEntry'
import { spamDetectionApi } from '@app/services'

export const extractEntitySpamListEntryIds = (data: SpamChecksResponse) => {
  const entitySpamListEntryIds = data.events
    .flatMap(
      (event) =>
        event.result.details.EntitySpamList?.flatMap(
          (detail) => detail.spamlistEntryIds ?? []
        ) ?? []
    )
    .filter((id) => !!id)
  return [...new Set(entitySpamListEntryIds)]
}
export const fetchSpamChecksByIds = async (
  eventIds: number[],
  signal: AbortSignal | undefined = undefined
) => {
  const { data } = await spamDetectionApi.post<SpamChecksResponse>(
    'check/ids',
    {
      checkIds: eventIds,
    },
    {
      signal,
    }
  )

  const entitySpamListEntryIds = extractEntitySpamListEntryIds(data)
  if (entitySpamListEntryIds.length > 0) {
    const entries = await fetchSpamListEntriesByIds(
      entitySpamListEntryIds,
      signal
    )

    const usersIds = [
      ...new Set(
        entries
          .map((entry) => entry.updatedByUserId || entry.createdByUserId)
          .filter((x) => x !== undefined)
      ),
    ]

    const users = usersIds.length > 0 ? await fetchChatUsers(usersIds) : []
    data.events.forEach((event) => {
      event.result.details.EntitySpamList?.forEach((detail) => {
        detail.spamlistEntryIds?.forEach((spamlistEntryId) => {
          detail.spamlistEntries = detail.spamlistEntries || []
          const entry = entries.find((entry) => entry.id == spamlistEntryId)
          if (entry) {
            const user = users.find(
              (user) =>
                user.id == entry.updatedByUserId ||
                user.id == entry.createdByUserId
            )
            entry.createdByUserName = user?.fullName ?? user?.email
            detail.spamlistEntries.push(entry)
          }
        })
      })
    })
  }
  return data
}

const fetchSpamListEntriesByIds = async (
  entryIds: number[],
  signal: AbortSignal | undefined
) => {
  const { data } = await spamDetectionApi.post<SpamListEntriesResponse>(
    'spamlist/ids',
    {
      entryIds,
    },
    {
      signal,
    }
  )
  return data.entries
}
